// libs
import { connect } from 'react-redux';

// redux
import { addToCartPlatform } from 'shared/store/cart/services';
import { updateAppCartCount } from 'shared/store/app/actions';
import { setCartToast } from 'shared/store/cart/actions';

import AddToBag from './AddToBag';

const mapDispatchToProps = {
  addToCartPlatform,
  setCartToast,
  updateAppCartCount,
};

export default connect(null, mapDispatchToProps)(AddToBag);
